import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.423 5.857a.545.545 0 000-.557.547.547 0 00-.43-.3H6.037a.548.548 0 00-.483.3.545.545 0 00.053.557l5.573 7.275c.145.187.224.417.225.654v5.678a.535.535 0 00.333.493c.064.03.134.044.204.043a.505.505 0 00.376-.16l2.147-2.144a.503.503 0 00.161-.375v-3.535c.001-.237.08-.467.226-.654l5.572-7.275z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
